var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostnl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg2",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style3"
  }, ".st3{fill:#fff}.st4{fill:#292e86}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    fill: "#b0b3b5",
    d: "M43.7 1.2c24 0 62.6 15.2 88.3 29.4 28.2 15.5 68 47.4 68 69.3 0 23.3-40.7 54.2-68.1 69.3-24.8 13.7-62.6 29.7-87.4 29.7-6.6 0-11.9-1.1-16-3.3C8.9 184.7 0 138.4 0 99.9c0-19.2 2.3-38.3 6.8-57C12.1 22.6 19.6 9.2 28.5 4.3c3.8-2 8.8-3.1 15.2-3.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M32.1 10.3c-16.2 9-25.2 53.3-25.4 88.5v2.2c.2 35.4 8.7 79.2 25.4 88.5 15.4 8.5 57.2-4 96.6-25.7 33.8-18.7 64.6-46.4 64.6-63.9 0-16.7-31.3-45.5-64.6-63.9C98.2 19.2 64.4 7.9 44.5 7.9c-5.2 0-9.4.7-12.4 2.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use15",
    overflow: "visible",
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g17",
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "rect7562_1_",
    cx: 328.5,
    cy: -7574.9,
    r: 1090.9,
    gradientTransform: "matrix(.19 -.09 -.06 -.13 -464 -906.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop21",
    offset: 0,
    stopColor: "#faa000"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop23",
    offset: 1,
    stopColor: "#e64600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect7562",
    fill: "url(#rect7562_1_)",
    d: "M6.2 7.2h187.6v185.3H6.2z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path250",
    d: "M152.9 128.5a.2.2 0 01-.2-.2v-16.5c0-3.7-1.2-5.3-4.2-5.3-1.3.1-2.5.4-3.6 1.1l-2.6 1.5-.2.4v18.8l-.2.2h-7.4a.2.2 0 01-.2-.2v-26.5c0-.4.4-.8.8-.8h6.8l.2.2v2.1l.2.2h.1l.2-.2a14.6 14.6 0 018.4-2.9c6 0 9.3 3.5 9.3 10v17.9l-.2.2h-7.2",
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path254",
    d: "M166.5 128.5a.2.2 0 01-.2-.2V87.5c0-.1 0-.2.2-.2 2.2 1 4.1 2.4 5.9 4.1 1 1.1 1.5 2.6 1.5 4.1v32.8l-.2.2h-7.2",
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path258",
    d: "M76.7 114.7c0-5.3-2.6-7.6-6.2-7.6s-6.3 2.3-6.3 7.6c0 4.8 2.6 7.6 6.2 7.6 3.6-.1 6.2-2.7 6.3-7.6m8.1 0c0 9.7-6.4 14.4-14.4 14.4S56 124.4 56 114.7c0-10 6.4-14.4 14.4-14.4s14.4 4.4 14.4 14.4",
    className: "st4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path262",
    d: "M122.3 93.3c0-.2-.1-.3-.3-.3a22 22 0 00-6 4.1 6.7 6.7 0 00-1.6 4.2V119c0 7.7 4.4 10.1 9.3 10.1 1.9.1 3.9-.2 5.7-1 .3-.2.5-.4.5-.8v-5c0-.1-.1-.3-.3-.3-1.1.3-2.1.6-3.2.7-2.5 0-4-1.2-4-5.1v-10.2c0-.1.1-.3.3-.3h6.6c.1 0 .3-.1.3-.3v-5.3c0-.5-.4-.9-.9-.9h-6.1c-.1 0-.3-.1-.3-.3v-7",
    className: "st4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path266",
    d: "M45.3 114.6c0-3.4-2.2-6.6-7.9-6.6h-3.1c-.1 0-.3.1-.3.3V121c0 .1.1.3.3.3h3.2c6.9 0 7.8-4.8 7.8-6.7m-19.3-13c0-.5.4-.9.9-.9h10.5c10.3 0 15.6 6.2 15.6 14.2s-6 13.6-15.8 13.6h-3c-.1 0-.3.1-.3.3v13c0 .2-.1.3-.3.3a22 22 0 01-6-4.1 6.2 6.2 0 01-1.6-4.1v-32.3",
    className: "st4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path270",
    d: "M107 113.4c-1.7-1-3.6-1.6-5.5-1.9l-1.9-.4c-2.3-.5-4.2-.9-4.2-2.5 0-1.3 1.3-2.2 3.2-2.2 3.3.1 6.6.7 9.7 1.9.2.1.4 0 .4-.2v-5.5c0-.4-.3-.8-.6-.9a31 31 0 00-8.5-1.5c-3.1-.2-6.2.7-8.8 2.4a8 8 0 00-3.3 6.5c0 6.1 5 7.3 9.8 8.4l.9.2c2.2.5 4.4 1 4.4 2.8 0 .5-.2 1-.6 1.3-.9.7-2.1 1-3.3.9-3.6-.2-7.1-.9-10.5-1.9H88c-.2 0-.3.1-.3.3v5.4c0 .4.2.7.6.9 3.1 1 6.4 1.6 9.7 1.7 8.2 0 12.4-3.2 12.4-9.1a7.5 7.5 0 00-3.4-6.6",
    className: "st4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path274",
    d: "M70.4 65.1l-.5-.2c-1.1-.9-2.1-1.9-3-3a.5.5 0 010-.7c.9-1.2 2-2.3 3.2-3.2l.3-.1.3.1c1.2.9 2.3 2 3.2 3.2.2.2.2.5 0 .7-.9 1.1-1.9 2.1-3 3l-.5.2zM57.9 85.3a.8.8 0 01-.8-.5l-.5-1.3c-.9-2.6-2.5-7-2.8-8.2-.5-1.9-.6-3.9 2-4.9l2.6-.9 3-.8h.5c.6 0 1.2.4 1.5 1a38.7 38.7 0 012.3 7c-.1.1-.2.2-.4.1h-2.6c-.3 0-.5-.1-.6-.4a21 21 0 00-1.3-3.5.5.5 0 00-.5-.3H60l-1.3.4c-.5.2-.7.8-.6 1.3a639 639 0 003.5 10.6l-.5.1-3.2.3zm10.9 0a.6.6 0 01-.6-.6L68 68.8l.2-.6.4-.2h3.7l.4.2c.2.2.2.4.2.6l-.2 15.9c.1.3-.2.6-.5.7H72l-3.2-.1zm11 0c-.2 0-.4 0-.5-.2a274.3 274.3 0 013.5-10.6c.1-.5-.1-1-.6-1.2l-1.3-.4h-.3c-.2 0-.4.1-.5.3a21 21 0 00-1.3 3.5c-.1.3-.3.4-.6.4h-2.6l-.4-.1v-.5c.6-2.2 1.4-4.4 2.4-6.5.2-.6.8-1 1.5-1h.5c.9.2 1.9.4 3 .8l2.6.9c2.6 1 2.6 2.9 2 4.9-.3 1.2-1.9 5.6-2.9 8.2l-.5 1.3c-.1.3-.4.5-.8.5l-3.2-.3zm-21.5 8.4c-.7 0-.9-.3-.9-1.1v-3c0-.7.6-1.2 1.2-1.2h23.7c.7 0 1.2.6 1.2 1.2v3c0 .8-.3 1.1-.9 1.1H58.3",
    className: "st3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostnl);
export default __webpack_public_path__ + "static/media/postnl.4977415fb77c706b3f6e3eae70c6643b.svg";
export { ForwardRef as ReactComponent };